var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgO02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.9,50l80.5,48.7C93.1,84.7,98.9,67.6,99,50c-0.1-17.6-6-34.7-16.7-48.7L1.9,50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6,100l-0.9-0.5L0,50L82.6,0l0.6,0.8C94,14.9,99.9,32.2,100,50c-0.1,17.8-6,35.1-16.8,49.2L82.6,100z M3.7,50l78.3,47.3 C92.3,83.6,97.9,67,97.9,49.9c-0.1-17.1-5.6-33.7-15.8-47.4L3.7,50z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO02);
export default __webpack_public_path__ + "static/media/O_02.d7b427584a96843dbece62b2ff62ef0a.svg";
export { ForwardRef as ReactComponent };